<article class="feed-card-container">

    <div class="flex w-full min-w-0 flex-row items-start justify-between gap-3">

        <div class="flex min-w-0 flex-1 items-center">
            <div class="shrink-0">
                <div
                    class="size-12 rounded-lg flex items-center justify-center bg-primary/10 dark:bg-primary/20">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-accent">
                        <path
                            d="M11.1 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.589 3.588A2.4 2.4 0 0 1 20 8v3.25" />
                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                        <path d="m21 22-2.88-2.88" />
                        <circle cx="16" cy="17" r="3" />
                    </svg>
                </div>
            </div>
            <div class="ml-3 min-w-0 flex-1">
                <h3 class="truncate text-base font-semibold text-primary">Brief Analysis Extracted!</h3>
                <p class="text-sm text-secondary">
                    Brief analysis has been completed. View and Enrich the brief.
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-col items-start justify-start h-full">

            <p class="text-sm text-secondary">
                {{ formatService.getTimeSinceUpdated(activity.date) }}
            </p>
        </div>
    </div>

    @if (briefQuestions() && briefQuestions()!.questions.length > 0) {

    <div class="flex w-full min-w-0 flex-col items-stretch justify-between gap-3 sm:flex-row sm:items-end">
        <div class="min-w-0 flex-1">
            <div
                class="max-w-7xl bg-white border border-gray-300 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none px-4 py-2 shadow-xs rounded-lg">
                <div class="grid grid-cols-1 gap-px sm:grid-cols-2 lg:grid-cols-4">
                    <div class="px-4">
                        <p class="text-sm font-medium text-secondary">Total Questions</p>
                        <p class="flex items-baseline gap-x-2">
                            <span class="text-xl font-semibold tracking-tight text-primary">{{
                                briefQuestions()!.questions.length }}</span>
                        </p>
                    </div>
                    <div class="px-4">
                        <p class="text-sm font-medium text-secondary">Requirements</p>
                        <p class="flex items-baseline gap-x-2">
                            <span class="text-xl font-semibold tracking-tight text-primary">{{ doQuestions()!.length
                                }}</span>
                        </p>
                    </div>
                    <div class="px-4">
                        <p class="text-sm font-medium text-secondary">Restrictions</p>
                        <p class="flex items-baseline gap-x-2">
                            <span class="text-xl font-semibold tracking-tight text-primary">{{ dontQuestions()!.length
                                }}</span>
                        </p>
                    </div>
                    <div class="px-4">
                        <p class="text-sm font-medium text-secondary">Questions to Enrich</p>
                        <p class="flex items-baseline gap-x-2">
                            <span class="text-xl font-semibold tracking-tight text-primary">{{
                                needEnrichmentQuestions()!.length }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="shrink-0">
            <button type="button" (click)="enrichBrief()"
                class="inline-flex items-center gap-x-1.5 rounded-full bg-primary px-2.5 py-1.5 text-sm text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                Enrich Brief
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="-mr-0.5 size-5">
                    <path
                        d="M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z" />
                    <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" />
                </svg>
            </button>
        </div>

    </div>


    } @else if (!briefQuestions() || briefQuestions()!.questions.length === 0) {
    <div
        class="border-l-4 border-yellow-400 bg-yellow-50 p-4 dark:border-yellow-500 dark:bg-yellow-500/10 rounded-r-md">
        <div class="flex">
            <div class="shrink-0">
                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                    class="size-5 text-yellow-400 dark:text-yellow-500">
                    <path
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
            </div>
            <div class="ml-3">
                <p class="text-sm text-yellow-700 dark:text-yellow-300">
                    Analysis Pending.
                    <a
                        class="font-medium text-yellow-700 underline hover:text-yellow-600 dark:text-yellow-300 dark:hover:text-yellow-200">Once
                        the analysis is complete, you will be able to enrich the brief.</a>
                </p>
            </div>
        </div>
    </div>

    } @else {
    <div
        class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-xs focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:border-gray-400 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none dark:focus-within:outline-primary dark:hover:border-white/25">
        <div class="shrink-0 p-2">
            <svg aria-hidden="true"
                class="mx-auto w-8 h-8 text-gray-200 animate-spin dark:text-gray-500 fill-primary"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
            </svg>
        </div>

        <div class="min-w-0 flex-1">
            <span aria-hidden="true" class="absolute inset-0"></span>
            <p class="text-sm font-medium text-gray-900 dark:text-white">Loading...</p>
            <p class="truncate text-sm text-gray-500 dark:text-gray-400">Fetching brief analysis.</p>
        </div>
    </div>
    }

</article>